import { render, staticRenderFns } from "./OptionRow.vue?vue&type=template&id=72e67cd6&scoped=true"
import script from "./OptionRow.vue?vue&type=script&lang=js"
export * from "./OptionRow.vue?vue&type=script&lang=js"
import style0 from "./OptionRow.vue?vue&type=style&index=0&id=72e67cd6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72e67cd6",
  null
  
)

export default component.exports